import TagsService from "external-services/tags-service";
import AdminService from "external-services/diary-admin-service/admin.service";

const NS = 'BookingsTags';

// requiring html templates so that hot reloading works
const template = require('./bookingsTags.html');

export default function BookingTags() {
  return {
    restrict: 'E',
    replace: true,
    controllerAs: 'vm',
    template,
    scope: {
      tags: '=',
      disabled: '=',
      allTags: '=',
      maxLength: '@',
      allowDeliveryFee: '<'
    },
    controller
  }
};

// just exported for unit tests
export function controller($scope, hardCodedTags) {
  "ngInject";


  //-- define public properties
  var vm = this;
  vm.sharedTagHeading = TagsService.sharedTagHeading;
  vm.diaryTagHeading= TagsService.diaryTagHeading;
  vm.allTags = [];
  vm.placeholder = 'Search for a Tag';
  //-- define public methods
  vm.onAddTag = onAddTag;
  vm.removedTag = removedTag;
  vm.querySearch = querySearch;

  //-- init
  $scope.tags = $scope.tags || [];
  const isTA = AdminService.getVenue().isTakeAwayMode;

  /**
   * Only want to show the delivery fee tag when `allowDeliveryFee` is true (booking options only)
   * and when takeAway mode is on. Otherwise we hide it from UI.
   */

  vm.$onInit = async function () {

    if (!$scope.allTags) { // to fix the tag issue not working while adding a new BO in diary
      const tags = await TagsService.getTags();
      vm.allTags = tags || [];
    } else {
      vm.allTags = $scope.allTags;
    }

    vm.allTags = vm.allTags.filter(t => {
      const isDeliveryFeeTag = t._id === hardCodedTags.DELIVERY_TAG_ID;
      if (isTA) {
        if (isDeliveryFeeTag) {
          return !!$scope.allowDeliveryFee;
        } else {
          return true;
        }
      }
      return !isDeliveryFeeTag;
    });
  }


  /**
   * Add a tag to the list
   * @param {Object} tag The tag to remove
   */
  function onAddTag(tagToAdd) {
    if (tagToAdd && tagToAdd.tagtype) {
      var matchingTags = $scope.tags.filter(function (tag) {
        return tag._id === tagToAdd._id;
      });
      // if tag already exists, or if tag length exceeds max length after adding, remove the tag
      if (matchingTags.length > 1 || $scope.maxLength && (parseInt($scope.maxLength) + 1) === $scope.tags.length) {
        $scope.tags.pop();
      } else {
        $scope.$emit('tags-updated');
        vm.searchText = '';
        vm.placeholder = null;
      }
    }
  }

  /** A tag has been removed */
  function removedTag(chip) {
    $scope.$emit('tags-updated');
    vm.placeholder = 'Search for a Tag';

    if (chip.noneditable === true) {
      $scope.tags.push(chip);
    }
  }

  function querySearch(query) {
    return TagsService.searchTags(query, vm.allTags);
  }
}
